<template>
  <div id="login_heaer_fixed">
    <div id="login_wrap_header">
      <b-navbar toggleable="lg" type="dark" variant="info" :sticky="tests">
        <b-nav-item href="https://www.dbclass.cn">
         <b-navbar-brand class="icon iconfont icon-logo-dbclass" style="font-size:28px"></b-navbar-brand>
        </b-nav-item>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-collapse id="nav-collapse" is-nav>
          <!-- <b-navbar-nav>
            <b-nav-item href="https://www.dbclass.cn">在线课堂</b-nav-item>
            <b-nav-item href="https://www.dbclass.cn/sskt.html">双师课堂</b-nav-item>
          </b-navbar-nav> -->
          <b-navbar-nav class="ml-auto">
           
            <b-nav-item href="https://www.dbclass.cn/download.html">下载</b-nav-item>
            <b-nav-item>
              <router-link to="/solution">计划</router-link>
            </b-nav-item>
            <b-nav-item>
              <a href="#" @click="go_student">登录/</a>
              <router-link to="/regist" class="login_zhuce">注册</router-link>
            </b-nav-item>
             <b-nav-item>
              <router-link to="/school-join" class="login_zhuce">学校入驻</router-link>
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
    </div>
  </div>
</template>
<script>
import Net_Work from "../apis/network.js";
export default {
  name: "headers",
  data() {
    return {
      tests: true,
      school: "学校",
      ishide: ""
    };
  },
  methods: {
    go_school() {
      // this.$emit("listen", this.school);
      // this.$router.push("/password-login");
      location.replace(Net_Work.publicPhoneAddress);
    },
    go_student() {
      window.sessionStorage.removeItem("schoolname");
      this.$router.push("/password-login");
      // location.reload();
    }
  },
  mounted() {}
};
</script>
<style lang="less" scoped>
@import "../assets/font/iconfont.css";
* {
  list-style: none;
  text-decoration: none;
}
* {
  list-style: none;
  text-decoration: none;
}
#login_heaer_fixed {
  width: 100%;
  height: 60px;
}
#login_wrap_header {
  width: 100%;
  height: 60px;
  background-color: #3366ff;
  position: fixed;
  z-index: 999;
  a {
    font-size: 16px;
    color: #fff;
  }
}

.nav-item,
.navbar-nav {
  text-align: center;
}
</style>
<style>
.bg-info {
  background: #3366ff !important;
}
</style>




// WEBPACK FOOTER //
// src/components/header.vue